import TspPage from './Page';

export default TspPage; 